<new-auth-page>
    <div left>
      <h1>Reset Password</h1>
      <p>Don't have an account?</p>
      <a [routerLink]="['/register']" class="link" trans>Register</a>
    </div>
    <form 
        form
        (ngSubmit)="resetPassword()" 
        *ngIf="errors$ | async as errors" 
        [formGroup]="form" 
        ngNativeValidate
    >
        <div class="header" trans>Reset your account password</div>

        <div class="many-inputs">
            <div class="input-container">
                <input type="email" formControlName="email" id="email" placeholder="Enter Email Address" required>
                <p class="error email-error" *ngIf="errors.email">
                    <mat-icon svgIcon="warning"></mat-icon>
                    {{errors.email}}
                </p>
            </div>

            <div class="input-container">
                <input type="password" formControlName="password" id="password" placeholder="New Password" required>
                <p class="error password-error" *ngIf="errors.password">
                    <mat-icon svgIcon="warning"></mat-icon>
                    {{errors.password}}
                </p>
            </div>

            <div class="input-container">
                <input type="password" formControlName="password_confirmation" name="password_confirmation" id="password_confirmation" placeholder="Confirm New Password" required>
            </div>
        </div>

        <button type="submit" [disabled]="loading$ | async" trans>Reset Password</button>
    </form>
</new-auth-page>
